@import "../../../global/gx-ide-common.scss";
@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/temporary-mercury-overrides/_button.scss";
@import "../../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content 1fr max-content;
  overflow: auto;
}

.section {
  display: contents;
}

.header {
  display: grid;
  grid-template-columns: 1fr max-content;
}

.data-mapping-grid-container,
.data-mapping-grid-container .field {
  overflow: auto;
  block-size: 100%;
}

.tabular-grid-application-declaration {
  overflow: auto;
}
ch-tabular-grid.empty-result::part(main) {
  // WA to avoid scrollbar flickering when displaying the empty-state message
  overflow: hidden;
}

.pill-tag {
  // base styles for this class defined on "gx-ide-common.scss"
  min-inline-size: 40px;
  margin-inline-end: 8px;
  padding-block: 1px;
  padding-inline: 4px;
  border-radius: 2px;
  text-align: center;
  font-size: var(--font-size-body-xs);
}

@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".tabular-grid-application-declaration",
  $tabular-grid-cell-node-type: "element",
  $tabular-grid-affected-columns-nth-list: (
    2
  )
);

// WA
.tabular-grid-cell:nth-child(2) {
  padding: 0 !important;
  display: grid;
  align-items: stretch;
  justify-content: stretch;
  --ds-focus-border-width: none;
}
.tabular-grid-cell:nth-child(3) {
  padding: 0 !important;
  align-items: center !important;
  justify-content: center !important;
}
.tabular-grid {
  overflow: auto;
}
